export default function() {
  return [
    {
      title: "Stats",
      to: "/covid-overview",
      htmlBefore: '<i class="material-icons">poll</i>',
      htmlAfter: ""
    },
    {
      title: "News",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: "/news",
    },
    {
      title: "State wise",
      htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/state-wise",
    },
    {
      title: "Country wise",
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: "/country-wise",
    },
    {
      title: "Do's and Don'ts",
      htmlBefore: '<i class="material-icons">emoji_people</i>',
      to: "/symptoms",
    },
    {
      title: "Developer",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/developer",
    },
    {
      title: "Donate",
      htmlBefore: '<i class="material-icons">error</i>',
      to: "/pm-cares-fund",
    }
  ];
}
